import {Message} from 'element-ui'
const ZH_REG = /[\u4e00-\u9fa5]/;
const appKey = "1673421098000112";
const secretKey = "36235a80dc544f02438fe5a5ae79c7aa";
const userId = "uid";
const baseUrl = "https://api.stkouyu.com:8443/";
const coreType = "emotion.eval.cn"; //评测题型内核

const sdk = {
  version: 16777472,
  source: 9,
  protocol: 2,
};

const audio = {
  audioType: "wav",
  sampleRate: 16000, //音频采样率
  channel: 1,
  sampleBytes: 2,
};

const legends = [
  {
    id: 1,
    name: "优秀发音",
  },
  {
    id: 2,
    name: "良好发音",
  },
  {
    id: 3,
    name: "中等发音",
  },
  {
    id: 4,
    name: "一般发音",
  },
];

const toFixed = (num, digits) => {
  if (typeof digits === 'undefined') {
    return num
  }

  return Number(num).toFixed(digits)
}

const getDigits = (num) => {
  var digits = 0
  var parts = num.toString().split('.')

  if (parts.length === 2) {
    digits = parts[1].length
  }

  return digits
}

function Mul(arg1, arg2, digits) {
  // 数字化
  var num1 = parseFloat(arg1).toString()
  var num2 = parseFloat(arg2).toString()
  var m = getDigits(num1) + getDigits(num2)
  var result = num1.replace('.', '') * num2.replace('.', '') / Math.pow(10, m)

  return toFixed(result, digits)
}

function per (detail, index) {
  const cnt = detail.cnt // 文字个数
  const curCnt = detail[`level_${index}`] // 优良中差发音文字个数
  if (!curCnt) {
    return 0
  }
  return parseFloat(Mul((curCnt / cnt), 100, 1))
}

function getRadom(min, max) {
  return parseInt(Math.random() * (max - min + 1) + min, 10);
}
var getStartSig = function () {
  var timestamp = new Date().getTime().toString();
  var sig = new jsSHA(appKey + timestamp + userId + secretKey, "TEXT").getHash(
    "SHA-1",
    "HEX"
  );
  return { sig: sig, timestamp: timestamp, userId: userId };
};

var getConSig = function () {
  var timestamp = new Date().getTime().toString();
  var sig = new jsSHA(appKey + timestamp + secretKey, "TEXT").getHash(
    "SHA-1",
    "HEX"
  );
  return { sig: sig, timestamp: timestamp };
};

var createUUID = (function (uuidRegEx, uuidReplacer) {
  return function () {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx"
      .replace(uuidRegEx, uuidReplacer)
      .toUpperCase();
  };
})(/[xy]/g, function (c) {
  var r = (Math.random() * 16) | 0,
    v = c == "x" ? r : (r & 3) | 8;
  return v.toString(16);
});

export default class STEvaluation {
  constructor(options) {
    this.options = options;
  }
  initReqOpts(refText) {
    const conSig = getConSig();
    const startSig = getStartSig();
    this.Skegn = {
      connect: {
        cmd: "connect",
        param: {
          sdk,
          app: {
            applicationId: appKey,
            sig: conSig.sig,
            timestamp: conSig.timestamp,
          },
        },
      },
      start: {
        cmd: "start",
        param: {
          audio,
          app: {
            applicationId: appKey,
            sig: startSig.sig,
            userId: startSig.userId,
            timestamp: startSig.timestamp,
          },
          request: {
            getParam: 1,
            attachAudioUrl: 1,
            coreType,
            refText,
            tokenId: createUUID(),
          },
        },
      },
    };
  }
  // 开启测评
  start(refText,fileBlod) {
    this.initReqOpts(refText);
    this.sendEval(fileBlod)
  }
  sendEval(file) {
		const fd = new FormData();
		fd.append("audio", file);
		fd.append("text", JSON.stringify(this.Skegn));
    try {
      const xhr = new XMLHttpRequest();
      xhr.open("post" , baseUrl + coreType);
      xhr.setRequestHeader( "Request-Index" , "0");//Request-Index 固定为0
      xhr.send(fd);
      xhr.onreadystatechange = () => {
        if(xhr.readyState == 4 && xhr.status == 200){
          let data = JSON.parse(xhr.responseText) || {};
          if (data.hasOwnProperty("errId")) {
            let params = {};
            if (data.errId === 53001) {
              // 测评字数超过上限
              Message.error('测评失败，字数超过1000字');
              params = { ...params, isError: true };
            }
            if (
              data.errId === 41030 &&
              data.error === "record concurrency is full"
            ) {
              // 测评达到并发
              params = { ...params, isFullRecord: true };
            }
            this.options.onScore && this.options.onScore(params);
            return;
          }
          if (data.hasOwnProperty("result")) {
            try {
              data = this.getReviewResult(data);
            } catch (e) {}
            // let params = { ...data, tempFilePath: this.tempFilePath };
            this.options.onScore && this.options.onScore(data);
          }
          // 
        }
      };
      xhr.onerror = err => {
        this.options.onScore && this.options.onScore({});
      }
    } catch (error) {
      this.options.onScore && this.options.onScore({});
    }
  }
  // 计算前后鼻音、平翘舌发音得分
  calcTongue(data, type) {
    if (data && data.length) {
      // 前后鼻音
      const nasalList = [
        "an",
        "ian",
        "uan",
        "üan",
        "en",
        "in",
        "uen",
        "ün",
        "ang",
        "iang",
        "uang",
        "eng",
        "ing",
        "ueng",
        "ong",
        "iong",
      ];
      // 平翘舌音
      const flatList = ["z", "c", "s", "zh", "ch", "sh", "r"];
      let nasalCount = 0; // 前后鼻音个数
      let nasalTotal = 0; // 前后鼻音发音得分总分
      let flatCount = 0; // 平翘舌个数
      let flatTotal = 0; // 平翘舌发音得分总分
      data.map((item) => {
        if (ZH_REG.test(item.word)) {
          item.phonemes.map((i) => {
            if (nasalList.includes(i.phone)) {
              nasalCount++;
              nasalTotal += i.pronunciation;
            }
            if (flatList.includes(i.phone)) {
              flatCount++;
              flatTotal += i.pronunciation;
            }
          });
        }
      });
      if (type === 1) {
        // 没有前后鼻音个数、平翘舌默认设置为100
        return nasalCount === 0 ? 100 : parseInt(nasalTotal / nasalCount);
      } else {
        return flatTotal === 0 ? 100 : parseInt(flatTotal / flatCount);
      }
    }
  }
  calSkill(data) {
    if (!data?.length) return 0;
    let total = 0;
    let count = 0;
    data.map((item) => {
      if (ZH_REG.test(item.word)) {
        count++;
        total += item.scores.overall_pron;
      }
    });
    return parseInt(total / count) || 0;
  }
  getSpecialLevel(retVal) {
    // 汉字统计
    legends.forEach((item, index) => {
      item.num = retVal["level_" + (index + 1)] || 0;
      item.per = per(retVal, index + 1);
    });
    retVal.legends = legends;
    // 总分=(完成度+准确度)÷2*70%+（流利度+朗读技巧+情感表达）÷3*30%  
    const {integrity,pronunciation,emotion,skillScore,fluency} = retVal;
    const numPer = (integrity + pronunciation) / 2 * 0.7 + (emotion + skillScore + fluency) / 3 * 0.3
    retVal.overall = Math.floor(numPer || 0); 
    return retVal;
  }
  // 测评结果处理
  getReviewResult(data = {}) {
    const { result } = data;
    const details = result.words || [];
    let nasal = this.calcTongue(details, 1);
    let tongue = this.calcTongue(details, 2);
    const retVal = {
      integrity: result.integrity, // 完整度
      fluency: result.fluency, // 流畅度
      tone: result.tone, // 声调分
      pronunciation: result.pronunciation, // 音素分
      emotion: result.emotion, // 情感表达
      phonemeScore: result.rhythm, // 韵律度，即音素分
      speed: result.speed,
      skillScore: this.calSkill(details),
      tongue, // 平翘舌
      nasal, // 前后鼻音
      overall: result.overall,
      cnt: 0,
      level: 3,
      recordId: data.recordId,
      result: data, // 原始结果
    };
    const overall = retVal.overall;
    let perNum = retVal.fluency + getRadom(-2, 2);
    if (perNum < 5) {
      perNum = 5;
    }
    if (perNum > 95) {
      perNum = 95;
    }
    if (overall > 80) {
      retVal.level = 1;
    } else if (overall > 60) {
      retVal.level = 2;
    } else {
      retVal.level = 3;
    }
    retVal.perNum = perNum;
    const wordMap = {};
    const wordCntMap = {};
    details.forEach((w) => {
      const word = w.word;
      if (ZH_REG.test(word)) {
        let overall = w.scores.overall || 0;
        // 计算每个文字的等级
        let level = 4;
        if (overall >= 90) {
          level = 1;
        } else if (overall >= 80 && overall < 90) {
          level = 2;
        } else if (overall >= 60 && overall < 80) {
          level = 3;
        } else {
          level = 4;
        }
        const levelKey = `level_${level}`;
        if (!retVal[levelKey]) {
          retVal[levelKey] = 0;
        }
        retVal[levelKey]++;
        retVal.cnt++;
        const charKey = w.word;
        if (!wordCntMap[charKey]) {
          wordCntMap[charKey] = 0;
        }
        const key = `${word}_${wordCntMap[charKey]}`;
        wordMap[key] = level;
        wordCntMap[charKey]++;
      }
    });
    retVal.wordMap = wordMap;
    this.getSpecialLevel(retVal);
    return retVal;
  }
}
